export const authFail =   [{
      "Body": "{{name}} failed to login with {{reason}}",
      "Event": {
          "name": "adminx",
          "reason": "bad password",
          "type": "user"
      },
      "NotificationType": "error",
      "RuleId": "ea676ee7-ec68-4a23-aba4-ba69feee4d8c",
      "State": "",
      "Title": "Login Failure",
      "Topic": "auth:failure",
      "time": "2024-05-16T02:59:55.004934733Z"
  },
  {
      "Body": "{{name}} failed to login with {{reason}}",
      "Event": {
          "name": "admin",
          "reason": "bad password",
          "type": "user"
      },
      "NotificationType": "error",
      "RuleId": "ea676ee7-ec68-4a23-aba4-ba69feee4d8c",
      "State": "",
      "Title": "Login Failure",
      "Topic": "auth:failure",
      "time": "2024-05-16T02:59:45.006823701Z"
  }
]

export const macViolation = [
  {
    Body:
      'MAC/IP violation from {{IP.SrcIP#Device}} on {{InDev#Interface}}',
    Event: {
      Action: 'blocked',
      Ethernet: { SrcMAC: '44:44:44:44:44:44' },
      IP: { SrcIP: '192.168.2.104', DstIP: '192.168.2.1' },
      InDev: 'eth1.1008'
    },
    NotificationType: 'warning',
    RuleId: '7f3266dd-7697-44ce-8ddd-36a006043509',
    State: '',
    Title: 'MAC Filter Violation',
    Topic: 'nft:drop:mac',
    time: '2024-05-16T03:04:08.542451645Z'
  }
]

export const dropPrivate = [
  {
    Body:
      'Dropped traffic from {{IP.SrcIP#Device}} to {{IP.DstIP}}:{{TCP.DstPort}}',
    Event: {
      Action: 'blocked',
      Ethernet: { SrcMAC: '55:55:55:55:55:55' },
      IP: { SrcIP: '192.168.2.105', DstIP: '10.20.30.40' },
      InDev: 'eth0',
      TCP: { SrcPort: 51234, DstPort: 443 }
    },
    NotificationType: 'warning',
    RuleId: '2adbec19-6b47-4a99-a499-ab0b8da652a8',
    State: '',
    Title: 'Drop Private Network Request',
    Topic: 'nft:drop:private',
    time: '2024-05-16T03:02:08.542451645Z'
  }
]

export const wifiAuthFail = [
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "33:33:33:33:33:33",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:44.471060819Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:44.241497687Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:44.008365992Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:43.786748003Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:43.548836972Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:43.308711854Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:18.456612389Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:18.223263821Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:17.992506096Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:17.763091775Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:17.53113661Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:13:17.300524496Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:11:07.175264698Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:11:06.945999702Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:11:06.717334741Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:11:06.489284111Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:11:06.247503381Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:11:06.021534763Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:06:07.460955411Z"
    },
    {
        "Body": "{{MAC#Device}} {{MAC}} failed wifi authentication {{Reason}} with type {{Type}}",
        "Event": {
            "MAC": "36:33:39:3c:28:b3",
            "Reason": "noentry",
            "Status": "",
            "Type": "sae"
        },
        "NotificationType": "warning",
        "RuleId": "f16e9a58-9f80-455c-a280-211bd8b1fd05",
        "State": "",
        "Title": "WiFi Auth Failure",
        "Topic": "wifi:auth:fail",
        "time": "2024-05-15T04:06:07.232928855Z"
    }
]


export const nftDrop = [
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "nD5TLcgY",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAE5J3p0AAQAAAAAAAAAAAAAAAAAAAAAAAJw+Uy3IGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBnD5TLcgYMgTAqAMaMwQAdqcADA9FbnRlcnRhbWVudFJvb23/AAAA",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "Aw==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "AXkDBg9scnf8",
                        "Length": 9,
                        "Type": 55
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "AZw+Uy3IGA==",
                        "Length": 7,
                        "Type": 61
                    },
                    {
                        "Data": "wKgDGg==",
                        "Length": 4,
                        "Type": 50
                    },
                    {
                        "Data": "AHanAA==",
                        "Length": 4,
                        "Type": 51
                    },
                    {
                        "Data": "RW50ZXJ0YW1lbnRSb29t",
                        "Length": 15,
                        "Type": 12
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 1,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 1313463965,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "9c:3e:53:2d:c8:18"
            },
            "IP": {
                "Checksum": 29119,
                "Contents": "RQABSEjmAAD/EXG/AAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 18662,
                "Length": 328,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE0fjMBAQYATknenQABAAAAAAAAAAAAAAAAAAAAAAAAnD5TLcgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQM3CQF5AwYPbHJ3/DkCBdw9BwGcPlMtyBgyBMCoAxozBAB2pwAMD0VudGVydGFtZW50Um9vbf8AAAA=",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T03:00:08.53007Z",
            "UDP": {
                "Checksum": 32307,
                "Contents": "AEQAQwE0fjM=",
                "DstPort": 67,
                "Length": 308,
                "Payload": "AQEGAE5J3p0AAQAAAAAAAAAAAAAAAAAAAAAAAJw+Uy3IGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBnD5TLcgYMgTAqAMaMwQAdqcADA9FbnRlcnRhbWVudFJvb23/AAAA",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T03:00:08.542451645Z"
    },
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "eONtDots",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAEUFexsAAAAAAAAAAAAAAAAAAAAAAAAAAHjjbQ6LbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDOQIF3DIEwKgCrjYEwKgCATcEAQMcBgwJUHVyYS04QjZD/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "Aw==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "wKgCrg==",
                        "Length": 4,
                        "Type": 50
                    },
                    {
                        "Data": "wKgCAQ==",
                        "Length": 4,
                        "Type": 54
                    },
                    {
                        "Data": "AQMcBg==",
                        "Length": 4,
                        "Type": 55
                    },
                    {
                        "Data": "UHVyYS04QjZD",
                        "Length": 9,
                        "Type": 12
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 0,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 1157987099,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "78:e3:6d:0e:8b:6c"
            },
            "IP": {
                "Checksum": 47411,
                "Contents": "RQABUAFqAAD/EbkzAAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 362,
                "Length": 336,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE8k4UBAQYARQV7GwAAAAAAAAAAAAAAAAAAAAAAAAAAeONtDotsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQM5AgXcMgTAqAKuNgTAqAIBNwQBAxwGDAlQdXJhLThCNkP/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T02:59:55.312778Z",
            "UDP": {
                "Checksum": 37765,
                "Contents": "AEQAQwE8k4U=",
                "DstPort": 67,
                "Length": 316,
                "Payload": "AQEGAEUFexsAAAAAAAAAAAAAAAAAAAAAAAAAAHjjbQ6LbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDOQIF3DIEwKgCrjYEwKgCATcEAQMcBgwJUHVyYS04QjZD/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T02:59:55.319141543Z"
    },
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "eONtDots",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAEUFexsAAAAAAAAAAAAAAAAAAAAAAAAAAHjjbQ6LbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEBOQIF3DcEAQMcBv8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "AQ==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "AQMcBg==",
                        "Length": 4,
                        "Type": 55
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 0,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 1157987099,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "78:e3:6d:0e:8b:6c"
            },
            "IP": {
                "Checksum": 47412,
                "Contents": "RQABUAFpAAD/Ebk0AAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 361,
                "Length": 336,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE86vYBAQYARQV7GwAAAAAAAAAAAAAAAAAAAAAAAAAAeONtDotsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQE5AgXcNwQBAxwG/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T02:59:54.05804Z",
            "UDP": {
                "Checksum": 60150,
                "Contents": "AEQAQwE86vY=",
                "DstPort": 67,
                "Length": 316,
                "Payload": "AQEGAEUFexsAAAAAAAAAAAAAAAAAAAAAAAAAAHjjbQ6LbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEBOQIF3DcEAQMcBv8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T02:59:54.064860058Z"
    },
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "nD5TLcgY",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAE5J3pwAAgAAAAAAAAAAAAAAAAAAAAAAAJw+Uy3IGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBnD5TLcgYMgTAqAMaMwQAdqcADA9FbnRlcnRhbWVudFJvb23/AAAA",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "Aw==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "AXkDBg9scnf8",
                        "Length": 9,
                        "Type": 55
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "AZw+Uy3IGA==",
                        "Length": 7,
                        "Type": 61
                    },
                    {
                        "Data": "wKgDGg==",
                        "Length": 4,
                        "Type": 50
                    },
                    {
                        "Data": "AHanAA==",
                        "Length": 4,
                        "Type": 51
                    },
                    {
                        "Data": "RW50ZXJ0YW1lbnRSb29t",
                        "Length": 15,
                        "Type": 12
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 2,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 1313463964,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "9c:3e:53:2d:c8:18"
            },
            "IP": {
                "Checksum": 29121,
                "Contents": "RQABSEjkAAD/EXHBAAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 18660,
                "Length": 328,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE0fjMBAQYATknenAACAAAAAAAAAAAAAAAAAAAAAAAAnD5TLcgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQM3CQF5AwYPbHJ3/DkCBdw9BwGcPlMtyBgyBMCoAxozBAB2pwAMD0VudGVydGFtZW50Um9vbf8AAAA=",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T02:59:26.239972Z",
            "UDP": {
                "Checksum": 32307,
                "Contents": "AEQAQwE0fjM=",
                "DstPort": 67,
                "Length": 308,
                "Payload": "AQEGAE5J3pwAAgAAAAAAAAAAAAAAAAAAAAAAAJw+Uy3IGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBnD5TLcgYMgTAqAMaMwQAdqcADA9FbnRlcnRhbWVudFJvb23/AAAA",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T02:59:26.246168744Z"
    },
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "EOLJrM4x",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAKx9oX0AAQAAAAAAAAAAAAAAAAAAAAAAABDiyazOMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBEOLJrM4xMgTAqALGMwQAdqcADA9BbGV4c0FwcGxlV2F0Y2j/AAAA",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "Aw==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "AXkDBg9scnf8",
                        "Length": 9,
                        "Type": 55
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "ARDiyazOMQ==",
                        "Length": 7,
                        "Type": 61
                    },
                    {
                        "Data": "wKgCxg==",
                        "Length": 4,
                        "Type": 50
                    },
                    {
                        "Data": "AHanAA==",
                        "Length": 4,
                        "Type": 51
                    },
                    {
                        "Data": "QWxleHNBcHBsZVdhdGNo",
                        "Length": 15,
                        "Type": 12
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 1,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 2893914493,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "10:e2:c9:ac:ce:31"
            },
            "IP": {
                "Checksum": 57840,
                "Contents": "RQABSNi0AAD/EeHwAAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 55476,
                "Length": 328,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE0qQsBAQYArH2hfQABAAAAAAAAAAAAAAAAAAAAAAAAEOLJrM4xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQM3CQF5AwYPbHJ3/DkCBdw9BwEQ4smszjEyBMCoAsYzBAB2pwAMD0FsZXhzQXBwbGVXYXRjaP8AAAA=",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T02:59:14.479174Z",
            "UDP": {
                "Checksum": 43275,
                "Contents": "AEQAQwE0qQs=",
                "DstPort": 67,
                "Length": 308,
                "Payload": "AQEGAKx9oX0AAQAAAAAAAAAAAAAAAAAAAAAAABDiyazOMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBEOLJrM4xMgTAqALGMwQAdqcADA9BbGV4c0FwcGxlV2F0Y2j/AAAA",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T02:59:14.48582018Z"
    },
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "nD5TLcgY",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAE5J3psAAQAAAAAAAAAAAAAAAAAAAAAAAJw+Uy3IGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBnD5TLcgYMgTAqAMaMwQAdqcADA9FbnRlcnRhbWVudFJvb23/AAAA",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "Aw==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "AXkDBg9scnf8",
                        "Length": 9,
                        "Type": 55
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "AZw+Uy3IGA==",
                        "Length": 7,
                        "Type": 61
                    },
                    {
                        "Data": "wKgDGg==",
                        "Length": 4,
                        "Type": 50
                    },
                    {
                        "Data": "AHanAA==",
                        "Length": 4,
                        "Type": 51
                    },
                    {
                        "Data": "RW50ZXJ0YW1lbnRSb29t",
                        "Length": 15,
                        "Type": 12
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 1,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 1313463963,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "9c:3e:53:2d:c8:18"
            },
            "IP": {
                "Checksum": 29123,
                "Contents": "RQABSEjiAAD/EXHDAAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 18658,
                "Length": 328,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE0fjUBAQYATknemwABAAAAAAAAAAAAAAAAAAAAAAAAnD5TLcgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQM3CQF5AwYPbHJ3/DkCBdw9BwGcPlMtyBgyBMCoAxozBAB2pwAMD0VudGVydGFtZW50Um9vbf8AAAA=",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T02:59:07.865577Z",
            "UDP": {
                "Checksum": 32309,
                "Contents": "AEQAQwE0fjU=",
                "DstPort": 67,
                "Length": 308,
                "Payload": "AQEGAE5J3psAAQAAAAAAAAAAAAAAAAAAAAAAAJw+Uy3IGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBnD5TLcgYMgTAqAMaMwQAdqcADA9FbnRlcnRhbWVudFJvb23/AAAA",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T02:59:07.899394037Z"
    },
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "pMM3QUo+",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAEQOrGQACgAAAAAAAAAAAAAAAAAAAAAAAKTDN0FKPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBpMM3QUo+MgTAqAISNgTAqAIBDANLMTP/AAAAAAAAAAAAAAAAAAAA",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "Aw==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "AXkDBg9scnf8",
                        "Length": 9,
                        "Type": 55
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "AaTDN0FKPg==",
                        "Length": 7,
                        "Type": 61
                    },
                    {
                        "Data": "wKgCEg==",
                        "Length": 4,
                        "Type": 50
                    },
                    {
                        "Data": "wKgCAQ==",
                        "Length": 4,
                        "Type": 54
                    },
                    {
                        "Data": "SzEz",
                        "Length": 3,
                        "Type": 12
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 10,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 1141812324,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "a4:c3:37:41:4a:3e"
            },
            "IP": {
                "Checksum": 65143,
                "Contents": "RQABSLwtAAD/Ef53AAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 48173,
                "Length": 328,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE0IxoBAQYARA6sZAAKAAAAAAAAAAAAAAAAAAAAAAAApMM3QUo+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQM3CQF5AwYPbHJ3/DkCBdw9BwGkwzdBSj4yBMCoAhI2BMCoAgEMA0sxM/8AAAAAAAAAAAAAAAAAAAA=",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T02:59:07.861103Z",
            "UDP": {
                "Checksum": 8986,
                "Contents": "AEQAQwE0Ixo=",
                "DstPort": 67,
                "Length": 308,
                "Payload": "AQEGAEQOrGQACgAAAAAAAAAAAAAAAAAAAAAAAKTDN0FKPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEDNwkBeQMGD2xyd/w5AgXcPQcBpMM3QUo+MgTAqAISNgTAqAIBDANLMTP/AAAAAAAAAAAAAAAAAAAA",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T02:59:07.880665328Z"
    },
    {
        "Body": "Drop Incoming Traffic to Router from {{IP.SrcIP}} to port {{TCP.DstPort}} {{UDP.DstPort}}",
        "Event": {
            "Action": "blocked",
            "DHCP": {
                "ClientHWAddr": "pMM3QUo+",
                "ClientIP": "0.0.0.0",
                "Contents": "AQEGAEQOrGQACQAAAAAAAAAAAAAAAAAAAAAAAKTDN0FKPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEBNwkBeQMGD2xyd/w5AgXcPQcBpMM3QUo+MwQAdqcADANLMTP/AAAAAAAAAAAAAAAAAAAAAAAAAAAA",
                "File": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Flags": 0,
                "HardwareLen": 6,
                "HardwareOpts": 0,
                "HardwareType": 1,
                "NextServerIP": "0.0.0.0",
                "Operation": 1,
                "Options": [
                    {
                        "Data": "AQ==",
                        "Length": 1,
                        "Type": 53
                    },
                    {
                        "Data": "AXkDBg9scnf8",
                        "Length": 9,
                        "Type": 55
                    },
                    {
                        "Data": "Bdw=",
                        "Length": 2,
                        "Type": 57
                    },
                    {
                        "Data": "AaTDN0FKPg==",
                        "Length": 7,
                        "Type": 61
                    },
                    {
                        "Data": "AHanAA==",
                        "Length": 4,
                        "Type": 51
                    },
                    {
                        "Data": "SzEz",
                        "Length": 3,
                        "Type": 12
                    }
                ],
                "Payload": null,
                "RelayAgentIP": "0.0.0.0",
                "Secs": 9,
                "ServerName": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==",
                "Xid": 1141812324,
                "YourClientIP": "0.0.0.0"
            },
            "Ethernet": {
                "DstMAC": "ff:ff:ff:ff:ff:ff",
                "HwType": 1,
                "SrcMAC": "a4:c3:37:41:4a:3e"
            },
            "IP": {
                "Checksum": 65144,
                "Contents": "RQABSLwsAAD/Ef54AAAAAP////8=",
                "DstIP": "255.255.255.255",
                "Flags": 0,
                "FragOffset": 0,
                "IHL": 5,
                "Id": 48172,
                "Length": 328,
                "Options": null,
                "Padding": null,
                "Payload": "AEQAQwE0Fy4BAQYARA6sZAAJAAAAAAAAAAAAAAAAAAAAAAAApMM3QUo+AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGOCU2M1AQE3CQF5AwYPbHJ3/DkCBdw9BwGkwzdBSj4zBAB2pwAMA0sxM/8AAAAAAAAAAAAAAAAAAAAAAAAAAAA=",
                "Protocol": 17,
                "SrcIP": "0.0.0.0",
                "TOS": 0,
                "TTL": 255,
                "Version": 4
            },
            "InDev": "eth0",
            "OutDev": "",
            "Prefix": "drop:input ",
            "Timestamp": "2024-05-16T02:59:06.569551Z",
            "UDP": {
                "Checksum": 5934,
                "Contents": "AEQAQwE0Fy4=",
                "DstPort": 67,
                "Length": 308,
                "Payload": "AQEGAEQOrGQACQAAAAAAAAAAAAAAAAAAAAAAAKTDN0FKPgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjglNjNQEBNwkBeQMGD2xyd/w5AgXcPQcBpMM3QUo+MwQAdqcADANLMTP/AAAAAAAAAAAAAAAAAAAAAAAAAAAA",
                "SrcPort": 68
            }
        },
        "NotificationType": "warning",
        "RuleId": "481822f4-a20c-4cec-92d9-dad032d2c450",
        "State": "",
        "Title": "Dropped Input",
        "Topic": "nft:drop:input",
        "time": "2024-05-16T02:59:06.580840677Z"
    }
]
